import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headerStyles: {
    height: 112,
    backgroundColor: "transparent",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      height: 130,
    },
    boxShadow: "none",
  },

  containerGrid: {
    margin: "0 auto",
  },

  buttonStyles: {
    height: 60,
    minWidth: 114,
    borderRadius: 30,
    background: "#f1c157",
    boxShadow: "0px 0px 20px rgba(239, 197, 103, 0)",
    fontSize: 16,
    marginLeft: 25,
    "&:hover": { backgroundColor: "#fbd88dff" },
    fontFamily: "var(--font-family-1)",
    fontWeight: 500,
    textAlign: "left",
    color: "#31343e",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      display: "none",
    },
  },

  toolBarStyles: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    minHeight: 110,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      flexDirection: "column",
      justifyContent: "flex-start",
    },
  },

  gutterStyles: {
    padding: 0,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      padding: "0",
    },
  },

  boxStyles: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      width: "100%",
      justifyContent: "center",
      background: "#19202F",
      height: 50,
      boxSizing: "border-box",
      padding: "0 15px",
      "& > div": {
        justifyContent: "space-between",
        overflowX: "auto",
        flexWrap: "nowrap",
        width: "100%",
        margin: 0,
        display: "flex",
      },
      "& $userLFNames": {
        display: "none",
      },
    },
  },

  mobileTopPartContainer: {
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      height: 80,
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      boxSizing: "border-box",
    },
  },

  mobileTopPartContainerWrapper: {
    [theme.breakpoints.down(400)]: {
      maxWidth: "95%",
    },
  },

  logo: {
    width: 171,
    height: 37,
    cursor: "pointer",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      width: 146,
      height: 30,
    },
  },

  UserSVGR: {
    display: "none",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      display: "block",
      cursor: "pointer",
    },
  },

  userLFNames: {
    marginLeft: 30,
    minWidth: 60,
    minHeight: 60,
    width: 60,
    height: 60,
    borderRadius: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1c157",
    boxShadow: "0px 0px 20px rgba(239, 197, 103, 0)",
    [theme.breakpoints.down(400)]: {
      marginLeft: 10,
    },
  },

  userLFNamesText: {
    fontFamily: "var(--font-family-1)",
    fontWeight: "bold",
    fontSize: 20,
    textAlign: "left",
    color: "#31343e",
    cursor: "pointer",
  },

  userLFNamesMobile: {
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      display: "none",
    },
  },

  changeLanguageContainer: {
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      display: "none !important",
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  changeLanguageContainer2: {
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      display: "none !important",
    },
  },

  buttonAndChangeLanguage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },

  menuPaper: {
    backgroundColor: "#19202F",
    color: "#fff",
    borderRadius: 12,
    minWidth: 220,
    overflow: "hidden",
  },

  menuList: {
    padding: 0,
  },

  menuHeaderItem: {
    pointerEvents: "none",
    cursor: "default",
    fontFamily: "var(--font-family-1)",
    fontWeight: 600,
    fontSize: 14,
    padding: "12px 16px",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
    backgroundColor: "rgba(255,255,255,0.03)",
  },

  menuItem: {
    fontFamily: "var(--font-family-1)",
    fontSize: 14,
    color: "#fff",
    padding: "12px 16px",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.08)",
    },
  },

  menuItemRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },

  menuItemText: {
    flex: 1,
    minWidth: 0,
  },

  menuItemIcon: {
    marginLeft: "auto",
    opacity: 0.75,
    width: 20,
    height: 20,
    flexShrink: 0,
  },

  menuPopover: {
    zIndex: 2000,
  },
}));

export default useStyles;
